module.exports = __webpack_public_path__ + "assets/img/ProductFeatures.cac6dae3.jpg";